import React from 'react';

import { Box, Text } from '@zillow/constellation-10';

import ProgressBar from '../ProgressBar';

import { StyledMobileGrid } from './styles';

/*
 * ProgressStepper
 *
 * usage example:
    <ProgressStepper activeIndex={1} isMobile={isMobile}>
        <Step label="Find Listings" mobileLabel="Find" />
        <Step label="Verify to claim" mobileLabel="Verify" />
        <Step label="Convert to ZRM" mobileLabel="Convert" />
    </ProgressStepper>
*/

export type Props = {
  children: Array<React.ReactElement>;
  activeIndex: number;
  alwaysShowProgressMeterTitle?: boolean;
  left: number;
  right: number;
  currentProgressStepLabel: string;
  currentStepIndex: number;
  isWizardComplete?: boolean;
  totalSteps: number;
  showDesktopViewBreakpoint: 'md' | 'xl' | 'xxl';
};

const ProgressStepper = ({
  children,
  activeIndex = -1,
  alwaysShowProgressMeterTitle = false,
  left,
  right,
  currentProgressStepLabel,
  currentStepIndex,
  isWizardComplete = false,
  totalSteps,
  showDesktopViewBreakpoint,
}: Props) => {
  const childrenArray = React.Children.toArray(children) as Array<React.ReactElement>;
  const steps = childrenArray.map((step, index) => {
    const newStep = React.cloneElement(step, {
      ...step.props,
      index,
      activeIndex,
      isActive: step.props.isActive || index === activeIndex,
      isCompleted: step.props.isCompleted || index < activeIndex,
      isWizardComplete,
      showDesktopViewBreakpoint,
    });

    return (
      <Box key={`step-container-${index}`} role="listitem" css={{ position: 'relative' }}>
        {index !== 0 && <ProgressBar isActive={index <= activeIndex} left={left} right={right} />}
        {newStep}
      </Box>
    );
  });
  return (
    <>
      <Box role="list" css={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))' }}>
        {steps}
      </Box>
      <StyledMobileGrid
        showDesktopViewBreakpoint={showDesktopViewBreakpoint}
        alwaysShowProgressMeterTitle={alwaysShowProgressMeterTitle}
      >
        <Box>
          <Text textStyle="body-sm-bold">{currentProgressStepLabel}</Text>
          {currentProgressStepLabel && <Text textStyle="body-sm">{` (${currentStepIndex}/${totalSteps})`}</Text>}
        </Box>
      </StyledMobileGrid>
    </>
  );
};

export { ProgressStepper };
export default ProgressStepper;
